import { parseAsInteger, parseAsString, useQueryStates } from 'nuqs';
import { parseAsSieveFilters } from '~/util/sieve/filter';
import { useDataTableFilterInjectContext } from './DataTableFilterInjectContext';

export function useQueryDataTableOptions() {
	const defaultFilters = useDataTableFilterInjectContext();
	const [searchOptions, setSearchOptions] = useQueryStates(
		{
			page: parseAsInteger.withDefault(1),
			pageSize: parseAsInteger.withDefault(10),
			sortColumn: parseAsString.withDefault(''),
			sortDirection: parseAsString.withDefault(''),
			filters: parseAsSieveFilters.withDefault(defaultFilters?.defaultFilters ?? [])
		},
		{
			throttleMs: 1000
		}
	);

	const clearSearchOptions = () => {
		setSearchOptions(
			{
				page: null,
				pageSize: null,
				sortColumn: null,
				sortDirection: null,
				filters: null
			},
			{ throttleMs: 0 }
		);
	};

	const filtersEmpty = JSON.stringify(searchOptions.filters) === JSON.stringify(defaultFilters?.defaultFilters ?? []);

	return { clearSearchOptions, searchOptions, setSearchOptions, filtersEmpty };
}
